<template>
  <div class="mt-2 mb-1 text-left crt-deal-create">
    <b-row>
      <b-col cols="4">
        <b-form-group
          label-cols="6"
          label-cols-lg="4"
          :label="mDealCirt.vocDbToLabel('Name')"
          class="text-left mb-2"
        >
          <b-input-group>
            <b-form-input
              class="text-right"
              v-model="model.ats.Name"
              style="min-width: 2em"
              placeholder="e.g. CIRT 2022-01-SUFFIX"
              required
              :state="state(validation, 'Name')"
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validation.Name }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-btn
          variant="primary"
          class="buttons_row--spaced"
          @click="validateModelWithUINotification"
          >Validate</b-btn
        >
        <b-btn
          variant="primary"
          class="buttons_row--spaced"
          v-if="$dealId == null"
          @click="createOrUpdateDeal()"
          >Create</b-btn
        >
        <b-btn
          variant="primary"
          class="buttons_row--spaced"
          v-if="$dealId != null"
          @click="createOrUpdateDeal({ isDealCreation: false })"
          >Update</b-btn
        >
        <b-btn
          variant="primary"
          class="buttons_row--spaced"
          v-if="$dealId != null"
          @click="
            createOrUpdateDeal({ isDealCreation: true, isDealClone: true })
          "
          >Clone</b-btn
        >
        <b-btn
          variant="info"
          class="buttons_row--spaced"
          v-if="$dealId != null"
          @click="deleteDeal()"
          >Delete</b-btn
        >
        <router-link
          v-if="$dealId != null && this.model.ats.Name != null"
          :to="{
            path: '/cirt_analysis',
            query: { dealName: this.model.ats.Name },
          }"
          class="btn btn-info buttons_row--spaced"
          >Goto CIRT</router-link
        >
      </b-col>
    </b-row>
    <b-row>
      <!--Collateral Information-->
      <b-col>
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            Collateral Information
          </caption>

          <!--Reference Pool Balance-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('ReferencePoolBalance')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.ReferencePoolBalance"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'ReferencePoolBalance')"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validation.ReferencePoolBalance }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--WAC-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('Wac')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.Wac"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'Wac')"
              ></b-form-input>
              <b-input-group-append>
                <span class="btn disabled">%</span>
              </b-input-group-append>
              <b-form-invalid-feedback>
                {{ validation.Wac }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--WAM-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('Wam')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.Wam"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'Wam')"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validation.Wam }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>
      <!--Structure-->
      <b-col>
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            Structure
          </caption>

          <!--Annual Premium Rate%-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('AnnualPremiumRatePct')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.AnnualPremiumRatePct"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'AnnualPremiumRatePct')"
              ></b-form-input>
              <b-col>&nbsp</b-col>
              <b-form-invalid-feedback>
                {{ validation.AnnualPremiumRatePct }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--Retention %-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('RetentionPct')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.RetentionPct"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'RetentionPct')"
              ></b-form-input>
              <b-input-group-append>
                <span class="btn disabled">%</span>
              </b-input-group-append>
              <b-form-input
                class="text-right"
                v-model="cField1"
                style="min-width: 2em"
                plaintext
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validation.RetentionPct }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--Limit of Liability %-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('LimitOfLiabilityPct')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.LimitOfLiabilityPct"
                :formatter="formatNumber"
                lazy-formatter
                style="min-width: 2em"
                decimalNumber="8"
                :state="state(validation, 'LimitOfLiabilityPct')"
              ></b-form-input>
              <b-input-group-append>
                <span class="btn disabled">%</span>
              </b-input-group-append>
              <b-form-input
                class="text-right"
                v-model="cField2"
                style="min-width: 2em"
                plaintext
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validation.LimitOfLiabilityPct }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>

      <!--Contract Information-->
      <b-col>
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            Contract Information
          </caption>

          <!--Effective Date-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('EffectiveDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                v-model="model.ats.EffectiveDate"
                :class="{ 'border border-danger': validation.EffectiveDate }"
              />
              <small
                v-if="validation.EffectiveDate"
                class="text-danger text-sm"
                >{{ validation.EffectiveDate }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--First Pay Date-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('FirstPayDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                v-model="model.ats.FirstPayDate"
                :class="{ 'border border-danger': validation.FirstPayDate }"
              />
              <small
                v-if="validation.FirstPayDate"
                class="text-danger text-sm"
                >{{ validation.FirstPayDate }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--Maturity Date-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('MaturityDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                v-model="model.ats.MaturityDate"
                :class="{ 'border border-danger': validation.MaturityDate }"
              />
              <small
                v-if="validation.MaturityDate"
                class="text-danger text-sm"
                >{{ validation.MaturityDate }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--Early Redemption Date-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('EarlyRedemptionDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                v-model="model.ats.EarlyRedemptionDate"
                :class="{
                  'border border-danger': validation.EarlyRedemptionDate,
                }"
              />
              <small
                v-if="validation.EarlyRedemptionDate"
                class="text-danger text-sm"
                >{{ validation.EarlyRedemptionDate }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--'Cancellation Percent-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealCirt.vocDbToLabel('CancellationPct')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                class="text-right"
                v-model="model.ats.CancellationPct"
                :formatter="formatNumber"
                lazy-formatter
                decimalNumber="8"
                style="min-width: 2em"
                :state="state(validation, 'CancellationPct')"
              ></b-form-input>
              <b-input-group-append>
                <span class="btn disabled">%</span>
              </b-input-group-append>
              <b-form-invalid-feedback>
                {{ validation.CancellationPct }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8">
        <!--Liability StepDowns-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            Liability StepDowns
          </caption>
          <thead class="header">
            <tr>
              <th>Start Period</th>
              <!--<th>End Period</th>-->
              <th>Reassess</th>
              <th>Balance Multiplier</th>
              <th>Delinquent Multiplier</th>
              <th>
                <b-btn
                  variant="outline-light"
                  class="m-2"
                  @click="addLiabilityStepDown"
                  >Add</b-btn
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(mLiabilityStepDown, idx) of model.ats.LiabilityStepDowns"
              :key="idx"
            >
              <!--Start Period-->
              <td>
                <b-form-input
                  class="text-right"
                  v-model="mLiabilityStepDown.ats.StartPeriod"
                  style="min-width: 2em"
                ></b-form-input>
              </td>
              <!--Reassess-->
              <td>
                <b-form-select v-model="mLiabilityStepDown.ats.Reassess">
                  <option :value="0">Monthly</option>
                  <option :value="1">Annual</option>
                </b-form-select>
              </td>
              <!--Balance Multiplier-->
              <td>
                <b-form-input
                  class="text-right"
                  v-model="mLiabilityStepDown.ats.BalanceMultiplier"
                  :formatter="formatNumber"
                  lazy-formatter
                  decimalNumber="8"
                  style="min-width: 2em"
                ></b-form-input>
              </td>
              <!--Delinquent Multiplier-->
              <td>
                <b-form-input
                  class="text-right"
                  v-model="mLiabilityStepDown.ats.DelinquentMultiplier"
                  :formatter="formatNumber"
                  lazy-formatter
                  decimalNumber="8"
                  style="min-width: 2em"
                ></b-form-input>
              </td>
              <td>
                <b-btn
                  variant="info"
                  class="m-2"
                  @click="removeLiabilityStepDown(idx)"
                  v-if="idx === model.ats.LiabilityStepDowns.length - 1"
                  >Remove</b-btn
                >
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col>
        <b-btn
          variant="info"
          class="buttons_row--spaced"
          v-if="$dealId != null"
          @click="exportDeal()"
          >Export to ODF</b-btn
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import FileSaver from "file-saver";

import mDealCirt from "@/models/mDealCirt";
import Datepicker from "vue2-datepicker";
import ObjAlertState from "@/components/common/alert/ObjAlertState";
import mDealCirtLiabilityStepDown from "@/models/mDealCirtLiabilityStepDown";
import { arrayElRemoveByIndex } from "@/utilities/ArrayUtils";
import formatter from "@/utilities/Formatter";
import UtilsData from "@/utilities/UtilsData";

import service from "@/services/HttpRequestService";
import { withUINotification } from "@/hooks/UserNotifications";
import { AxiosSaveContentToFile } from "@/utilities/AxiosHelper";
import { generateDealCloneName } from "./dealsNameGenerator";

export default {
  name: "CirtDealEditor",
  props: {
    dealId: {
      type: String | Number,
      default: null,
    },
  },
  data() {
    return {
      createdDealId: null,
      mDealCirt,
      model: new mDealCirt({
        LiabilityStepDowns: mDealCirt.DefaultLiabilityStepDownList(),
      }),
      validation: {},
    };
  },
  async created() {
    if (this.$dealId) {
      await this.loadDealDetailsById(this.$dealId);
    }
  },
  watch: {
    $route(to, from) {
      const { query: { dealId = null } = {} } = to;
      if (dealId != null) {
        this.loadDealDetailsById(this.$dealId);
      }
    },
  },
  computed: {
    $dealId() {
      return this.createdDealId ?? this.dealId;
    },
    cField1() {
      let v1 = UtilsData.castToNumber(this.model.ats.ReferencePoolBalance, 8);
      let v2 = UtilsData.castToNumber(this.model.ats.RetentionPct, 8);
      let res = this.formatNumber((v1 * v2) / 100);
      return res;
    },
    cField2() {
      let v1 = UtilsData.castToNumber(this.model.ats.ReferencePoolBalance, 8);
      let v2 = UtilsData.castToNumber(this.model.ats.LimitOfLiabilityPct, 8);
      let res = this.formatNumber((v1 * v2) / 100);
      return res;
    },
  },
  methods: {
    async loadDealDetailsById(dealId) {
      await withUINotification.bind(this)(async () => {
        const {
          data: { Name = null, Structure = {} },
        } = await service.getCustomDeal(dealId);
        const dealStructure = JSON.parse(Structure);
        this.model.setRawFields({
          Name,
          ...dealStructure,
        });
      }, `Failed to get the deal structure. Id: ${dealId}.`);
    },
    addLiabilityStepDown() {
      this.model.ats.LiabilityStepDowns.push(new mDealCirtLiabilityStepDown());
    },
    removeLiabilityStepDown(idx) {
      arrayElRemoveByIndex(this.model.ats.LiabilityStepDowns, idx);
    },
    async validateModelWithUINotification() {
      await withUINotification.bind(this)(
        async () => {
          if (!this.validateModel()) {
            throw new Error();
          }
        },
        `Invalid data, Deal cannot be created.`,
        `Deal validation succeeded.`
      );
    },
    validateModel() {
      this.validation = {};
      this.model.validate();
      if (!this.model._localValidationStatus) {
        for (let exc of this.model._localValidationResults) {
          this.validation[exc.fieldSysName] = `${exc.msg}`;
        }
        this.$forceUpdate();
        return false;
      }
      return true;
    },
    async createOrUpdateDeal(options = {}) {
      const { isDealCreation = true, isDealClone = false } = options;
      const payload = this.model.getRawFieldsFormattedForBackEnd();
      const modelRef = this.model;

      if (isDealClone) {
        payload.Name = generateDealCloneName(payload.Name);
      }

      const isOperationSuccessful = await withUINotification.bind(this)(
        async () => {
          if (!modelRef.validate()) {
            throw new Error("Invalid data, Deal cannot be created.");
          }
          const dealPayload = {
            Type: "CIRT",
            ...payload,
          };
          if (isDealCreation) {
            const { data: { Id = null } = {} } =
              await service.createCustomCIRTDeal(dealPayload);
            if (Id == null) {
              throw new Error("Failed to generate Id for a new deal.");
            }
            this.createdDealId = Id;
          } else {
            await service.updateCustomCIRTDeal(this.$dealId, dealPayload);
          }
        },
        `Failed to ${isDealCreation ? "create" : "update"} the deal${
          payload.Name?.length ? " " + payload.Name + "." : "."
        }`,
        `Custom CIRT deal ${payload.Name} has been ${
          isDealCreation ? "created" : "updated"
        } successfully.`
      );
      if (isOperationSuccessful) {
        if (isDealClone) {
          this.$router.push({
            path: "/deal_create",
            query: { dealType: "CIRT", dealId: this.createdDealId },
          });
        }
      }
    },
    async deleteDeal() {
      const payload = this.model.getRawFieldsFormattedForBackEnd();
      if (
        !(await this.$root.confirmCurrentStep(
          `Do you want to delete deal: ${payload.Name}`
        ))
      ) {
        return;
      }
      const result = await withUINotification.bind(this)(async () => {
        await service.deleteCustomDeal(this.$dealId);
      }, `Failed to delete the deal ${payload.Name}`);
      if (result) {
        await this.$root.redirectToDealCatalog();
      }
    },
    async exportDeal(isDealCreation) {
      const { Name: dealName = "CIRT 2022-00-GENERIC" } =
        this.model.getRawFieldsFormattedForBackEnd();
      await withUINotification.bind(this)(async () => {
        const response = await service.getCustomDeal(this.$dealId, true);
        AxiosSaveContentToFile(`${dealName}.ODF`, response);
      }, `Failed to export the deal.`);
    },
    state(o, f) {
      if (o.hasOwnProperty(f)) return false;
      return null;
    },
    formatNumber(value, event) {
      const n = event?.target?.attributes?.decimalNumber?.nodeValue || 2;
      const res = formatter.formatAsNumber(value, {
        minSignsAfterDot: 2,
        maxSignsAfterDot: n,
      });
      return res;
    },
  },
  components: {
    Datepicker,
  },
};
</script>

<style scoped>
.buttons_row--spaced {
  min-width: 90px;
  margin-right: 2px;
  margin-bottom: 2px;
}
</style>
